const feedbackEndpoint =
  "https://getform.io/f/9d34a314-1d02-4ea7-b2fb-dfde1dcf123c"

export function sendFeedbackForm(params) {
  return fetch(feedbackEndpoint, {
    mode: "cors",
    method: "post",
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
    },
    body: JSON.stringify(params),
  })
}

const careersEndpoint =
  "https://getform.io/f/daf4b0ae-5fe2-46e8-bd70-871c5fba56b5"

export function sendCareersForm(params) {
  return fetch(careersEndpoint, {
    mode: "cors",
    method: "post",
    body: params,
  })
}
